import type { UseModalProps } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import { useCreateOtherDocumentMutation } from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { withCan } from "@src/utils/components/permissions";
import { FormMode } from "@src/utils/types";
import { observer } from "mobx-react-lite";
import type React from "react";
import { type FunctionComponent, useContext, useState } from "react";
import { DocumentsCtx } from "../../StoreDocuments";
import { ModalOtherDocumentForm } from "./ModalOtherDocumentForm";
import {
  FormOtherDocumentCtx,
  StoreOtherDocumentForm,
} from "./StoreOtherDocumentForm";

export const ModalCreateOtherDocument: FunctionComponent<
  React.PropsWithChildren<UseModalProps>
> = withCan(
  { do: "otherDocument_create", fail: false },
  observer(function ModalCreateOtherDocument(props) {
    const documentsStore = useContext(DocumentsCtx);

    const [store] = useState(() => {
      return StoreOtherDocumentForm.create();
    });

    const onClose = () => {
      store.form.form.reset();
      props.onClose();
    };

    const [create, req] = useCreateOtherDocumentMutation({
      onCompleted() {
        documentsStore.refetchOtherDocs?.();
        onClose();
      },
      ...onError(),
    });

    return (
      <FormOtherDocumentCtx.Provider value={store}>
        {props.isOpen && (
          <ModalOtherDocumentForm
            title={t`Add new other document`}
            {...props}
            primaryActionContent={t`Save document`}
            mode={FormMode.CREATE}
            loading={req.loading}
            onSubmit={async (vars) => {
              await create({ variables: { input: { ...vars } } });
            }}
            onClose={onClose}
            prefillFormFields={documentsStore.prefillFormFields}
          />
        )}
      </FormOtherDocumentCtx.Provider>
    );
  }),
);
